import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { currentSub, enablePush, disablePush, pushSupported } from "@/lib/push";
import { useAuth } from "@/context/AuthContext";

const COPY = {
  patient: ["Notifications on this device", "Alerts for consultations (15-minute reminder, doctor has joined) and every order step – even when the app is closed."],
  doctor: ["Notifications on this device", "Instant alerts for new bookings, joint-consult requests, changes and a 15-minute reminder before each consultation."],
  partner: ["New-order alerts on this device", "Instant alert for every new order plus a reminder when 10 minutes are left in the 20-minute response window."],
};

export function PushToggle({ compact = false }) {
  const { user } = useAuth();
  const [title, text] = COPY[user?.role] || COPY.patient;
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { currentSub().then((s) => setOn(!!s)).catch(() => {}); }, []);
  const toggle = async (v) => {
    setBusy(true);
    try { v ? await enablePush() : await disablePush(); setOn(v); toast.success(v ? "Notifications turned on for this device" : "Notifications turned off on this device"); }
    catch (e) { toast.error(e.message || "Could not change notifications"); } finally { setBusy(false); }
  };
  return (
    <section className={`surface ${compact ? "p-4 mb-6" : "p-6"} flex items-start gap-3`} data-testid="push-toggle-section">
      <BellRing className="h-5 w-5 text-[#2412B5] mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0"><p className="font-semibold text-sm">{title}</p>
        <p className="text-xs muted mt-0.5">{pushSupported() ? text : "Not supported in this browser. On iPhone, add Nirogyam to your Home Screen (iOS 16.4+) and open it from there."}</p></div>
      <Switch checked={on} disabled={busy || !pushSupported()} onCheckedChange={toggle} data-testid="push-toggle" />
    </section>
  );
}
